import { Contract } from './contract';
import { Note } from './note';

export class AgentEngagementEventContract {
	public id: number;
	public agentEngagementEventId: number;
	public contractId: string;
	public termValue: number;
	public isComplete: boolean;
	public noteId: string;

	public contract: Contract;
	public note: Note;

	constructor(agentEngagementEventContract: AgentEngagementEventContract) {
		Object.assign(this, agentEngagementEventContract);

		this.contract = this.contract ? new Contract(this.contract) : this.contract;
		this.note = this.note ? new Note(this.note) : this.note;
	}
}
